import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { portalService } from '../services/portalService';

const PortalContext = createContext();

export const usePortal = () => {
  const context = useContext(PortalContext);
  if (!context) {
    throw new Error('usePortal must be used within a PortalProvider');
  }
  return context;
};

export const PortalProvider = ({ children }) => {
  const { user, isAuthenticated } = useAuth();
  const [companies, setCompanies] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUserCompanies = async () => {
    if (!isAuthenticated) return;
    
    try {
      setLoading(true);
      setError(null);
      const data = await portalService.getUserCompanies();
      setCompanies(data);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching companies:', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const data = await portalService.getCategories();
      setCategories(data);
    } catch (err) {
      console.error('Error fetching categories:', err);
    }
  };

  const logAssetClick = async (assetId, companyId) => {
    try {
      await portalService.logAssetClick(assetId, companyId);
    } catch (err) {
      console.error('Error logging asset click:', err);
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchUserCompanies();
      fetchCategories();
    }
  }, [isAuthenticated]);

  const value = {
    companies,
    categories,
    loading,
    error,
    fetchUserCompanies,
    fetchCategories,
    logAssetClick,
    refreshCompanies: fetchUserCompanies
  };

  return (
    <PortalContext.Provider value={value}>
      {children}
    </PortalContext.Provider>
  );
};